import Box from '@mui/material/Box';
import { FormCheckBox, useTrackedFormik } from '@omnigenbiodata/ui';
import * as yup from 'yup';
import { useTranslation } from 'react-i18next';
import { StepProps } from '../../../../core/types/common.types';
import EnrolmentStepContainer from '../EnrolmentStepContainer';

function Consent6Step({ currentStep, onStepForward, onStepBack, values }: StepProps) {
  const { t } = useTranslation('portal');

  const validationSchema = yup.object().shape({
    consent6: yup
      .boolean()
      .required(t('forms.consent6.msg.required') as string)
      .oneOf([true], t('forms.consent6.msg.required') as string),
  });

  const formik = useTrackedFormik(
    {
      initialValues: { consent6: false, ...values },
      validationSchema,
      onSubmit: (values: any) => {
        onStepForward(values);
      },
    },
    'consent6',
  );

  return (
    <EnrolmentStepContainer
      onSubmit={formik.handleSubmit}
      title={t('enrol.consent6.title')}
      text={t('enrol.consent6.text') as string}
      onBack={onStepBack}
      showBack={currentStep > 0}
    >
      <Box mb={4} px={{ xs: 3, sm: 0 }}>
        <FormCheckBox
          error={formik.errors.consent6}
          name="consent6"
          label={t('forms.consent6.label')}
          onChange={formik.handleChange}
          touched={formik.touched.consent6}
          value={formik.values.consent6}
        />
      </Box>
    </EnrolmentStepContainer>
  );
}

export default Consent6Step;
